import React from "react";
import Header from "../../components/header";
import Footer from "../../components/footer";

const LayoutComponent = ({ children, isHomePage = false }) => {
  return (
    <>
      <Header isHomePage={isHomePage} />
      <div style={{ marginBottom: isHomePage ? "0px" : "70px" }} />
      {children}
      <Footer />
    </>
  );
};
export default LayoutComponent;
